import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useScript } from 'app/hooks/useScript';
import { useCheckoutFrameStore } from 'app/context/checkoutStore';
import { useErrorStore } from 'app/context/errorStore';
import { useThreeDsFlow } from 'app/pages/useThreeDsFlow';
import { ThreeDSStep, traceSetupStep } from 'app/pages/frames/lib/3DS/trace';
import { getSongbirdIntegrity } from 'common/songbird';

export const useCardinalScript = () => {
  const { t } = useTranslation();
  const { status, loadScript } = useScript();
  const { checkoutRequest, entity } = useCheckoutFrameStore();
  const { setError } = useErrorStore();
  const { start3DSProcess } = useThreeDsFlow();

  const getCardinalUrl = (): string => {
    const { liveMode } = checkoutRequest!;
    return liveMode ? import.meta.env.VITE_CARDINAL_SONGBIRD_URL : import.meta.env.VITE_CARDINAL_SONGBIRD_LIVEMODE_URL;
  };

  useEffect(() => {
    if (checkoutRequest && entity) {
      const url = getCardinalUrl();
      loadScript(url, getSongbirdIntegrity(url));
    }
  }, [checkoutRequest, entity]);

  useEffect(() => {
    if (status === 'ready') {
      start3DSProcess();
    }
  }, [status]);

  useEffect(() => {
    if (status === 'error' && checkoutRequest) {
      const url = getCardinalUrl();
      const withIntegrity = getSongbirdIntegrity(url) ? 'yes' : 'no';
      traceSetupStep(
        ThreeDSStep.SETUP_FAILED,
        {
          checkoutId: checkoutRequest.id ?? null,
          chargeId: checkoutRequest.chargeId ?? null,
          entityName: entity?.name ?? null,
          companyId: checkoutRequest.companyId ?? null,
        },
        new Error(`Songbird script failed to load: ${url} (integrity: ${withIntegrity})`),
      );
      setError(new Error(t('errors.threeDsScriptLoad')));
    }
  }, [status]);
};
